<template>
  <v-app>
    <admin-layout v-if="isAdmin"></admin-layout>
      <div v-else>
          <v-fade-transition mode="out-in">
            <router-view></router-view>
          </v-fade-transition>
      </div>

  </v-app>
</template>

<script>
// import {serverBus} from './main'

import AdminLayout from "./layouts/AdminLayout";

export default {
  components: {
    AdminLayout
  },

  created() {
    // let self = this;
    //
    // serverBus.$on('logged-in-out', (loggedIn) => {
    //     self.loggedIn = loggedIn;
    //
    //     if (self.loggedIn) {
    //         serverBus.$emit('get-permissions');
    //     } else {
    //         this.$store.commit('setUser', {});
    //         this.$store.commit('setPermissions', []);
    //
    //         localStorage.setItem('token', '-1');
    //     }
    // });
    //
    // serverBus.$on('get-permissions', () => {
    //     this.getPermissions();
    // });
  },

  mounted() {
    // let sessionExpired = (new Date() > new Date(localStorage.getItem('session_expires')));
    //
    // this.loggedIn = localStorage.getItem('token') !== '-1' && !sessionExpired;
    //
    // if (this.loggedIn) this.getPermissions();
    //
    // if (sessionExpired) {
    //     this.loggedIn = false;
    //
    //     localStorage.setItem('token', '-1');
    // }
    //
    // this.getPermissions();
  },

  computed: {
    isAdmin () {
      return this.$route.path.match('admin');
    }
  },

  methods: {
    // getPermissions: function () {
    //     this.$axios.post('ostalo/dozvole')
    //         .then(response => {
    //             this.$store.commit('setPermissions', response.data);
    //         })
    //         .catch(() => {
    //             serverBus.$emit('logged-in-out', false);
    //         });
    // },
  },

  data: function () {
    return {
      loggedIn: false,
    }
  }
}
</script>
